import { useHotelsStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { CheckInInstructions } from "@b2bportal/lodging-api";
import { HotelShopSection, useCheckInInformation } from "@tenant/hotels";
import clsx from "clsx";
import defaultStyles from "./CheckInInformationSection.module.scss";

export interface CheckInInformationSectionComponentProps
  extends PlatformComponentProps {
  checkInInformation?: CheckInInstructions;
}

const COMPONENT_KEY = CoreHotelsComponent.CheckInInformationSection;

export const CheckInInformationSection = (
  props: CheckInInformationSectionComponentProps
) => {
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { children, className } = props;

  const { context, text } = useCheckInInformation(props);

  if (!context.showCheckInTime && !context.showCheckOutTime) {
    return null;
  }
  return (
    <HotelShopSection className={clsx(block, className)} title={text.title}>
      <div className={cn("content")}>
        {context.showCheckInTime ? (
          <div className={cn("content-section")}>
            <h4 className={cn("content-title")}>{text.checkInTitle}</h4>
            <div className={cn("content-info")}>{text.checkInTime}</div>
          </div>
        ) : null}
        {context.showCheckOutTime ? (
          <div className={cn("content-section")}>
            <h4 className={cn("content-title")}>{text.checkOutTitle}</h4>
            <div className={cn("content-info")}>{text.checkOutTime}</div>
          </div>
        ) : null}
      </div>

      {children}
    </HotelShopSection>
  );
};
